var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83329 4.49999C8.83329 4.03976 8.46019 3.66666 7.99996 3.66666C7.53973 3.66666 7.16663 4.03976 7.16663 4.49999C7.16663 4.96022 7.53973 5.33332 7.99996 5.33332C8.46019 5.33332 8.83329 4.96022 8.83329 4.49999Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83329 6.66666C6.83329 6.29847 7.13177 5.99999 7.49996 5.99999H8.16663C8.53481 5.99999 8.83329 6.29847 8.83329 6.66666V10.6667H9.33329C9.70148 10.6667 9.99996 10.9651 9.99996 11.3333C9.99996 11.7015 9.70148 12 9.33329 12H6.99996C6.63177 12 6.33329 11.7015 6.33329 11.3333C6.33329 10.9651 6.63177 10.6667 6.99996 10.6667H7.49996V7.33332C7.13177 7.33332 6.83329 7.03485 6.83329 6.66666Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 0.666656C5.97511 0.666656 4.14087 1.4882 2.81451 2.81453C1.48818 4.14089 0.666626 5.97514 0.666626 7.99999C0.666626 10.0248 1.48817 11.8591 2.81451 13.1854C4.14086 14.5118 5.97511 15.3333 7.99996 15.3333C10.0248 15.3333 11.8591 14.5118 13.1854 13.1854C14.5117 11.8591 15.3333 10.0248 15.3333 7.99999C15.3333 5.97514 14.5117 4.1409 13.1854 2.81454C11.8591 1.4882 10.0248 0.666656 7.99996 0.666656ZM3.75731 3.75735C4.84385 2.67083 6.34294 1.99999 7.99996 1.99999C9.65698 1.99999 11.1561 2.67083 12.2426 3.75735C13.3291 4.84388 14 6.34297 14 7.99999C14 9.65701 13.3291 11.1561 12.2426 12.2426C11.1561 13.3291 9.65698 14 7.99996 14C6.34294 14 4.84385 13.3291 3.75732 12.2426C2.6708 11.1561 1.99996 9.65701 1.99996 7.99999C1.99996 6.34297 2.67079 4.84389 3.75731 3.75735Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.eb7e3db2deb70bea9c622341cab7c812.svg";
export { ForwardRef as ReactComponent };